// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {BoundaryType} from './boundary-type.js'
import {SeqId} from './seq-id.js'

export class Boundary {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Boundary {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  location(obj?: SeqId): SeqId | null {
    return (obj || new SeqId()).__init(this.bb_pos, this.bb!)
  }

  type(): BoundaryType {
    return this.bb!.readInt8(this.bb_pos + 12)
  }

  static sizeOf(): number {
    return 16
  }

  static createBoundary(
    builder: flatbuffers.Builder,
    location_site: number,
    location_timestamp: number,
    location_index: number,
    type: BoundaryType
  ): flatbuffers.Offset {
    builder.prep(4, 16)
    builder.pad(3)
    builder.writeInt8(type)
    builder.prep(4, 12)
    builder.writeInt32(location_index)
    builder.writeInt32(location_timestamp)
    builder.pad(2)
    builder.writeInt16(location_site)
    return builder.offset()
  }
}
